import { getUserInfo } from '@/api/userApi';
import { captureException } from '@sentry/browser';
const checkOnboardingInfo = ({
  channelCategory,
  privacy,
}: {
  channelCategory?: string;
  privacy?: {
    birthday: string;
    gender: string;
  };
}) => {
  if (!Boolean(channelCategory)) return true;

  if (
    (channelCategory === 'player' ||
      channelCategory === 'common' ||
      channelCategory === 'creator') &&
    !Boolean(privacy)
  )
    return true;

  return false;
};

const getIsNeedOnboarding = async ({
  uid,
  token,
}: {
  uid: string;
  token: string;
}) => {
  try {
    const { data: userData } = await getUserInfo({
      uid,
      idToken: token,
    });

    const isNeedOnboarding = checkOnboardingInfo({
      channelCategory: userData.channel.category,
      privacy: userData.privacy,
    });

    return isNeedOnboarding;
  } catch (error) {
    captureException(error);
    return false;
  }
};

export default getIsNeedOnboarding;
